// Angular
import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
// RxJS
import { BehaviorSubject } from 'rxjs';
import { AsideMenuModel } from '../../../_config/menu.config';
// Services
import { MenuConfigService } from './menu-config.service';

@Injectable({ providedIn: 'root' })
export class MenuAsideService {
  menuList$ = new BehaviorSubject<AsideMenuModel[]>([]);
  pathname$ = new BehaviorSubject<string>('');

  constructor(private menuConfigService: MenuConfigService) {
    this.loadMenu();
  }

  loadMenu() {
    this.menuConfigService.onConfigUpdated$.subscribe((datas) => {
      if (datas.length > 0) {
        this.pathname$.subscribe(
          (pathname: string) => {
            const location = pathname.split('/');
            let activeURL = '';
            if (location[0] == '') {
              activeURL = location[1];
            } else {
              activeURL = location[0];
            }
            if (isNotNullOrUndefined(datas) && datas.length > 0) {
              const data = datas.find(x => x.page == '/' + activeURL);
              if (data != undefined) {
                this.menuList$.next(data.items);
              }
            }
          }
        );
      }
    });
  }
}
